import { render } from "./Flickity.vue?vue&type=template&id=3851ba01&scoped=true"
import script from "./Flickity.vue?vue&type=script&lang=js"
export * from "./Flickity.vue?vue&type=script&lang=js"

import "./Flickity.vue?vue&type=style&index=0&id=3851ba01&lang=css&scoped=true"

import exportComponent from "/Users/casey/Documents/Development/visualspace_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3851ba01"]])

export default __exports__